// @ts-nocheck

import WarpElement from '@warp-ds/elements-core';
import '@warp-ds/elements';
import '@warp-ds/icons/elements/chevron-left-24';
import { html, render } from 'lit';
import { BrandText } from './brand-text';
import { showModal } from './onboarding-modal';

/* 
Mount (or entry point) component for the onboarding modal.
Can be used server-side, and when connected on the client will render the onboarding-modal element in a
designated modal div, parallell to the main content.
*/
class OnboardingModalEntrypoint extends WarpElement {
    connectedCallback() {
        super.connectedCallback();

        const { body } = window.document;
        const brand = this.getAttribute('brand') || '';
        const i18n = this.i18n; // Pass Lingui i18n instance
        const brandTextInstance = new BrandText(i18n);
        const brandScreenText = brandTextInstance.getBrandText(brand);
        const buttonText = brandTextInstance.getButtonText();

        // TODO: REMOVE AFTER TESTING IS DONE deletes the localStorage key value for onboarding in local env
        function handleLocalOnboarding() {
            // Define the environments to check for
            const localEnvs = ['localhost', '127.0.0.1', 'local.finn.no', 'dev.dba.dk'];

            // Check if the current hostname matches local environments
            if (localEnvs.includes(window.location.hostname)) {
                // Attempt to retrieve the onboarding value from localStorage
                const onboardingValue = localStorage.getItem('onboarding');

                // If it exists, remove it from localStorage
                if (onboardingValue !== null) {
                    localStorage.removeItem('onboarding');
                    console.log('Onboarding value retrieved and deleted:', onboardingValue);
                    return onboardingValue; // Return the value if needed for further processing
                } else {
                    console.log('Onboarding value does not exist in localStorage.');
                }
            } else {
                console.log('Not in a local or development environment.');
            }
            return null;
        }
        handleLocalOnboarding();

        if (body && showModal()) {
            // Get the modal div or create and attach one.
            let modalDiv = document.querySelector('#modal-div');
            if (!modalDiv) {
                modalDiv = document.createElement('div');
                modalDiv.id = 'modal-div';
                body.appendChild(modalDiv);
            }

            // Render modal.
            render(
                html`<onboarding-modal
                    locale="${this.getAttribute('locale') || 'en'}"
                    messages="${this.getAttribute('messages') || '{}'}"
                    brand="${brand}"
                    .brandScreenText=${brandScreenText}
                    .buttonText=${buttonText}
                ></onboarding-modal>`,
                modalDiv,
            );
        }
    }
}

if (!customElements.get('onboarding-modal-entrypoint')) {
    customElements.define('onboarding-modal-entrypoint', OnboardingModalEntrypoint);
}
